let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("chaHI")).then(() => parcelRequire('2HSAx'));